import { HTTP } from "./common";

export const AdminApi = {

  celery_stat() {
    return HTTP.get(`dashboard/get_celery_stat/`).then((response) => {
      return response.data;
    });
  },
  workers_stat() {
    return HTTP.get(`dashboard/get_workers_stat/`).then((response) => {
      return response.data;
    });
  },
  parser_object_stat() {
    return HTTP.get(`dashboard/get_parser_object_stat/`).then((response) => {
      return response.data;
    });
  },
  user_stat() {
    return HTTP.get(`dashboard/get_user_stat/`).then((response) => {
      return response.data;
    });
  },
  project_stat() {
    return HTTP.get(`dashboard/get_project_stat/`).then((response) => {
      return response.data;
    });
  },
  // manual_send_autoreply(data) {
  //   return HTTP.post(`dashboard/manual_send_autoreply/`, data).then((response) => {
  //     return response.data;
  //   });
  // },


};


